<template>
  <!-- Filter-Bereich -->
  <div v-if="agendatype === 'filter'" class="filter-controls">
    <div class="row">
        <div class="col-lg-9">
          <!-- Suchfeld -->
          <p class="mb-3">
            <input placeholder="Search title or speaker name"
                   type="search"
                   :value="searchText"
                   @input="$emit('update:searchText', ($event.target as HTMLInputElement).value)" 
                   class="form-control">
          </p>
    
          <!-- Download Buttons -->
          <div class="row mb-3">
            <div class="col-lg-8 col-12">
              <!-- AUSKOMMENTIERT SOLANGE WIR DIE DATEIEN NICHT BEKOMME HABEN -->
              <!--<a href="/files/gmf_programoverview.pdf" class="btn btn-primary m-0 float-start me-2" target="_blank">-->
              <!--  <i class="far fa-arrow-to-bottom"></i> Download full program-->
              <!--</a>-->
              <a href="/files/gmf_siteplan.pdf" class="btn btn-primary m-0 float-start" target="_blank">
                <i class="far fa-arrow-to-bottom"></i> Download site plan
              </a>
            </div>
            <div class="col-lg-4 col-12">
              <a class="resetfilter btn btn-outline-primary float-end" @click="clearFilter()">
                <i class="fal fa-trash"></i> Clear Filter
              </a>
            </div>
          </div>
    
          <!-- Event Typ Filter -->
           <div class="mb-3">
               <p class="fw-bold mb-2 mt-3">Event type</p>
               <div class="btn-group flex-wrap" role="group" v-if="Object.keys(eventTypes).length > 0">
                   <template v-for="(count, typeKey) in eventTypes" :key="typeKey">
                      <button 
                          class="btn me-2 mb-2 filter-button-sm"
                          :class="[getEventTypeClass(typeKey)]"
                          @click="toggleFilter('eventTypes', typeKey)"
                      >
                          <i :class="['me-1', activeFilters.eventTypes[typeKey] ? 'fas fa-check-circle' : 'far fa-circle']"></i>
                          {{ formatTypeKey(typeKey) }} ({{ count }})
                      </button>
                   </template>
               </div>
               <p v-else>No event types found.</p>
           </div>
    
          <!-- Location Filter -->
          <div class="mb-3" v-if="Object.keys(locationTypes).length > 0">
              <p class="fw-bold mb-2 mt-3">Location</p>
              <div class="btn-group flex-column flex-md-row w-100" role="group" aria-label="Location filter">
                <template v-for="(count, loc) in locationTypes" :key="loc">
                    <input type="checkbox" class="btn-check" :id="`loc-filter-${loc.replace(/\s+/g, '-')}`" 
                          :checked="activeFilters.locations[loc]" 
                          @change="toggleLocationFilter(loc)" 
                          autocomplete="off">
                    <label class="btn btn-outline-secondary filter-button-sm" :for="`loc-filter-${loc.replace(/\s+/g, '-')}`">
                        <i :class="['me-1', activeFilters.locations[loc] ? 'fas fa-check-circle' : 'far fa-circle']"></i>
                        {{ loc }}
                    </label>
                </template>
            </div>
          </div>
    
           <!-- Datums Filter -->
           <div class="mb-3" v-if="props.showDates !== false">
               <p class="fw-bold mb-2 mt-3">Date</p>
               <div class="btn-group" role="group">
                    <input type="checkbox" class="btn-check" id="date-day1" 
                           :checked="activeFilters.days.day1" 
                           @change="toggleDayFilter('day1')">
                    <label class="btn btn-outline-primary filter-button-sm" for="date-day1">
                        <i :class="['me-1', activeFilters.days.day1 ? 'fas fa-check-circle' : 'far fa-circle']"></i>
                        Monday, July 7, 2025
                    </label>
    
                    <input type="checkbox" class="btn-check" id="date-day2" 
                           :checked="activeFilters.days.day2" 
                           @change="toggleDayFilter('day2')">
                     <label class="btn btn-outline-primary filter-button-sm" for="date-day2">
                         <i :class="['me-1', activeFilters.days.day2 ? 'fas fa-check-circle' : 'far fa-circle']"></i>
                         Tuesday, July 8, 2025
                     </label>
               </div>
           </div>
       </div> <!-- Schließt col-lg-9 -->
     </div> <!-- Schließt row -->
  </div> <!-- Schließt filter-controls -->

  <!-- Timeline-Ansicht wird von AgendaOverview gesteuert -->
  <!-- <div v-if="props.agendatype === 'timeline'" class="agenda-grid"> ... </div> --> 

  <!-- Standard-Ansicht (z.B. Liste, Video) -->
  <div v-else>

    <div class="mt-4" v-if="noDaysSelected || activeFilters.days.day1">
      <h4 class="font-weight-bold pb-3">MONDAY, JULY 7, 2025</h4>
      <div class="row">
        <div v-if="agendaPointsDay1.length == 0 && route.name === 'Mediathek'">
          <p>No videos on demand available yet.</p>
        </div>
        <AgendaEntry v-for="(ae, aeindex) in filteredAgendaPointsDay1"
                     :key="`agp1${ae.objvalueid}`"
                     :ae="ae"
                     :agendatype="props.agendatype"/>
        <div v-if="route.name === 'Calendar'">
          <h5 class="pb-2 font-weight-bold">Appointments</h5>
          <MeetingEntry v-for="ae in meetings1"
                        :key="`agp_1${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings2"
                        :key="`agp_2${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings3"
                        :key="`agp_3${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings4"
                        :key="`agp_4${ae.objvalueid}`"
                        :ae="ae"/>
        </div>
      </div>
    </div>

    <div class="mt-4" v-if="noDaysSelected || activeFilters.days.day2">
      <h4 class="font-weight-bold pb-3">TUESDAY, JULY 8, 2025</h4>
      <div class="row">
        <div v-if="agendaPointsDay2.length == 0 && route.name === 'Mediathek'">
          <p>No videos on demand available yet.</p>
        </div>
        <AgendaEntry v-for="ae in filteredAgendaPointsDay2"
                     :key="`agp2${ae.objvalueid}`"
                     :ae="ae"
                     :agendatype="props.agendatype"/>
        <div v-if="route.name === 'Calendar'">
          <h5 class="pb-2 font-weight-bold">Appointments</h5>
          <MeetingEntry v-for="ae in meetings1_2"
                        :key="`agp_1_2${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings2_2"
                        :key="`agp_2_2${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings3_2"
                        :key="`agp_3_2${ae.objvalueid}`"
                        :ae="ae"/>
          <MeetingEntry v-for="ae in meetings4_2"
                        :key="`agp_4_2${ae.objvalueid}`"
                        :ae="ae"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, defineEmits, watch } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'

import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import AgendaEntry from "@/components/AgendaEntry.vue"
import _ from "lodash"
import type { AgendaPoint, Meetings } from "@/store/i/types"
import MeetingEntry from "@/components/MeetingEntry.vue"

// Props
const props = defineProps<{
  agendatype?: string
  location?: string
  showFilter?: boolean
  showDates?: boolean
  searchText?: string
  activeFilters?: {
    eventTypes: Record<string, boolean>
    days: {
      day1: boolean
      day2: boolean
    }
  }
  day?: number
}>()

// Emit Definition für Updates (Jetzt definiert)
const emit = defineEmits(['update:searchText', 'update:activeFilters'])

// Store, Route, Router
const store = useStore()
const route = useRoute()

// Reactive State
const searchtext = ref('')

// Inline Typdefinitionen (da sie nicht exportiert werden)
type EventTypeKey = string; // Oder spezifischer, falls bekannt
type EventTypes = Record<EventTypeKey, boolean>;
type Days = { day1: boolean; day2: boolean };
type LocationFilters = Record<string, boolean>;

// Event Type Mapping
const eventTypeMap: Record<EventTypeKey, number> = {
  networking: 4,
  exhibitor_events: 5,
  plenary_sessions: 6,
  breakout_sessions: 7
}

// Active Filters State
const activeFilters = ref({
  eventTypes: {} as EventTypes, 
  days: { day1: true, day2: true } as Days, 
  locations: {} as LocationFilters
})

// Computed Properties
const noDaysSelected = computed(() => {
  return !activeFilters.value.days.day1 && !activeFilters.value.days.day2;
})

const filterItems = (items: AgendaPoint[]) => {
  const swords = _.map(
      _.words(searchtext.value),
      s => new RegExp(_.escapeRegExp(s), 'iu')
  )

  localStorage.setItem("TextFilter", searchtext.value)

  const activeEventTypeFilters: EventTypeKey[] = Object.entries(activeFilters.value.eventTypes)
      .filter(([_key, value]) => value)
      .map(([key, _value]) => key as EventTypeKey)

  const lookForEventTypeNumber = activeEventTypeFilters.map((k) => eventTypeMap[k])
  
  const activeLocationFilters = Object.entries(activeFilters.value.locations)
      .filter(([_key, value]) => value)
      .map(([key, _value]) => key)

  return _.filter(
      items,
      (item) => {
        return (swords.length === 0 || swords.some((r) => r.test(item.title + ' ' + item.speakers)))
            && (lookForEventTypeNumber.length === 0 || lookForEventTypeNumber.includes(item.eventtype))
            && (activeLocationFilters.length === 0 || 
               (item.location && typeof item.location === 'string' && 
                activeLocationFilters.includes(item.location)))
      }
  )
}


/*
 ERSTMAL AUSKOMMENTIERT DA ZU KLÄREN IST WELCHE DATEN 2025 ES SEIN SOLLEN UND OB DAS HARDGECODET BLEIBT
 OHNE AUSKOMMENTIEREN BEKOMMT MAN SONST ERSTMAL MIT DEN TESTDATEN NIX ANGEZEIT!!!
*/

/*
const agendaPointsDay1 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Mon Jun 17 2024"
  )

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    )
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Mon Jun 17 2024" && ap.show_video
    )
  }

  return filterItems(items)
})

const agendaPointsDay2 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Tue Jun 18 2024"
  )

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    )
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.dbstate > -1 && (new Date(ap.startdate)).toDateString() == "Tue Jun 18 2024" && ap.show_video
    )
  }

  return filterItems(items)
})
*/

const agendaPointsDay1 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => {
        // Filtere nach 7. Juli 2025
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && // Juli = 6 (0-basiert)
               itemDate.getFullYear() === 2025;
      }
  );

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && new Date(ap.enddate).getTime() > new Date().getTime()
    );
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.show_video
    );
    // we don't need to filter on the video page
    return items;
  }

  return filterItems(items);
})

const agendaPointsDay2 = computed(() => {
  let items = _.filter(
      store.getters['i/orderedAgendaPoints'],
      (ap: AgendaPoint) => {
        // Filtere nach 8. Juli 2025
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && // Juli = 6 (0-basiert)
               itemDate.getFullYear() === 2025;
      }
  );

  if (props.agendatype === "calendar") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => _.has(store.state.i.me.fav_agenda_items, ap.objvalueid) && 
                            new Date(ap.enddate).getTime() > new Date().getTime()
    );
  }

  if (props.agendatype === "video") {
    items = _.filter(
        items,
        (ap: AgendaPoint) => ap.show_video
    );
    // we don't need to filter on the video page
    return items;
  }

  return filterItems(items);
})

// Meetings computed properties
const meetings1 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 1 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 2 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings3 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 3 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings4 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 4 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 7 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings1_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 1 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings2_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 2 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings3_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 3 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

const meetings4_2 = computed(() => {
  return _.filter(
      store.getters['i/orderedMeetings'],
      (ap: Meetings) => {
        const itemDate = new Date(ap.startdate);
        return ap.dbstate > -1 && 
               ap.status == 4 && 
               new Date(ap.enddate).getTime() > new Date().getTime() &&
               itemDate.getDate() === 8 && 
               itemDate.getMonth() === 6 && 
               itemDate.getFullYear() === 2025;
      }
  );
})

// Filtert die Agenda-Items, um sicherzustellen, dass nur gültige AgendaPoint-Objekte verwendet werden
const filteredAgendaPointsDay1 = computed(() => {
  if (!Array.isArray(agendaPointsDay1.value)) return [];
  
  // Filtere zuerst nach Location, wenn eine angegeben ist
  let items = agendaPointsDay1.value.filter((item): item is AgendaPoint => 
    item !== null && typeof item === 'object' && 'objvalueid' in item
  );

  // Wende Filter an
  if (props.location) {
    items = items.filter(item => item.location === props.location);
  }

  if (props.searchText) {
    const searchLower = props.searchText.toLowerCase();
    items = items.filter(item => 
      item.title.toLowerCase().includes(searchLower) ||
      (item.subtitle?.toLowerCase().includes(searchLower)) ||
      (item.hosted_by?.toLowerCase().includes(searchLower))
    );
  }

  // Sortiere nach Startzeit
  items = _.sortBy(items, [
    item => new Date(item.startdate).getTime()
  ]);

  // Berechne die Position basierend auf der Startzeit
  return items.map(item => {
    const startTime = new Date(item.startdate);
    const endTime = new Date(item.enddate);
    const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const duration = (endTime.getTime() - startTime.getTime()) / (1000 * 60); // Dauer in Minuten
    
    return {
      ...item,
      topPosition: `${((startMinutes - 8 * 60) / 15) * 3}rem`, // 3rem pro 15-Minuten-Slot
      height: `${(duration / 15) * 3}rem` // Höhe basierend auf der Dauer
    };
  });
});

const filteredAgendaPointsDay2 = computed(() => {
  if (!Array.isArray(agendaPointsDay2.value)) return [];
  
  // Filtere zuerst nach Location, wenn eine angegeben ist
  let items = agendaPointsDay2.value.filter((item): item is AgendaPoint => 
    item !== null && typeof item === 'object' && 'objvalueid' in item
  );

  // Wende Filter an
  if (props.location) {
    items = items.filter(item => item.location === props.location);
  }

  if (props.searchText) {
    const searchLower = props.searchText.toLowerCase();
    items = items.filter(item => 
      item.title.toLowerCase().includes(searchLower) ||
      (item.subtitle?.toLowerCase().includes(searchLower)) ||
      (item.hosted_by?.toLowerCase().includes(searchLower))
    );
  }

  // Sortiere nach Startzeit
  items = _.sortBy(items, [
    item => new Date(item.startdate).getTime()
  ]);

  // Berechne die Position basierend auf der Startzeit
  return items.map(item => {
    const startTime = new Date(item.startdate);
    const endTime = new Date(item.enddate);
    const startMinutes = startTime.getHours() * 60 + startTime.getMinutes();
    const duration = (endTime.getTime() - startTime.getTime()) / (1000 * 60); // Dauer in Minuten
    
    return {
      ...item,
      topPosition: `${((startMinutes - 8 * 60) / 15) * 3}rem`, // 3rem pro 15-Minuten-Slot
      height: `${(duration / 15) * 3}rem` // Höhe basierend auf der Dauer
    };
  });
});

// Computed Properties für Event Types und Locations (mit Debugging)
const eventTypes = computed(() => {
  const types: Record<string, number> = {};
  const agendaPoints = store.getters['i/orderedAgendaPoints'] || [];
  if (!Array.isArray(agendaPoints) || agendaPoints.length === 0) {
      return {};
  }
  agendaPoints.forEach((point: AgendaPoint, index: number) => {
    if (point) {
      const eventTypeNumber = point.eventtype;
      const typeKey = getEventTypeKey(eventTypeNumber); 
      if (typeKey) {
        types[typeKey] = (types[typeKey] || 0) + 1;
      }
    } 
  });
  return types;
});

const locationTypes = computed(() => {
  const locations: Record<string, number> = {};
  const agendaPoints = store.getters['i/orderedAgendaPoints'] || [];
   if (!Array.isArray(agendaPoints) || agendaPoints.length === 0) {
      return {};
  }
  agendaPoints.forEach((point: AgendaPoint, index: number) => {
    if (point && point.location && typeof point.location === 'string') {
      const locationString = point.location.trim();
      if (locationString !== '') {
        locations[locationString] = (locations[locationString] || 0) + 1;
      }
    }
  });
   const sortedLocations: Record<string, number> = {};
   Object.keys(locations).sort().forEach(key => {
       sortedLocations[key] = locations[key];
   });
  return sortedLocations; 
});

// Funktion zum Konvertieren von Eventtyp-Nummern in Schlüssel (korrigiert/überprüft)
const getEventTypeKey = (typeNumber: number): EventTypeKey | null => {
  const map: Record<number, EventTypeKey> = {
    // Korrektes Mapping basierend auf eventTypeMap oben
    6: 'plenary_sessions',  
    7: 'breakout_sessions', 
    5: 'exhibitor_events',  
    4: 'networking'         
  };
  const key = map[typeNumber];
  return key || null;
};

// Funktion gibt die originalen etX-Klassennamen zurück (bleibt so)
const getEventTypeClass = (typeKey: EventTypeKey): string => {
  const number = eventTypeMap[typeKey]; // Holt 4, 5, 6, oder 7
  return number ? `et${number}` : 'et-default'; // Originale Klasse (z.B. et6)
};

// Hilfsfunktion zum Formatieren der Schlüssel
const formatTypeKey = (key: string): string => {
    return key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

// Methods
const clearFilter = () => {
  searchtext.value = '' 
  emit('update:searchText', ''); 
  filtersInitialized = false; 
  initializeFilters(); 
}

// NEUE Allgemeine Toggle-Funktion
const toggleFilter = (filterType: 'eventTypes' | 'locations' | 'days', key: string) => {
    if (filterType === 'days') {
        if (key === 'day1' || key === 'day2') {
            activeFilters.value.days[key] = !activeFilters.value.days[key];
        }
    } else {
        if (activeFilters.value[filterType]) {
            activeFilters.value[filterType][key] = !activeFilters.value[filterType][key];
        }
    }
    emit('update:activeFilters', activeFilters.value);
};

const toggleDayFilter = (type: keyof Days) => {
  activeFilters.value.days[type] = !activeFilters.value.days[type]
  localStorage.setItem("DayFilter", JSON.stringify(activeFilters.value.days))
}

const toggleLocationFilter = (loc: string) => {
  // Sicherstellen, dass der Key existiert bevor umgeschaltet wird
  if (activeFilters.value.locations.hasOwnProperty(loc)) {
      activeFilters.value.locations[loc] = !activeFilters.value.locations[loc];
  } else {
      // Falls Key noch nicht existiert (sollte nicht vorkommen), initialisieren
      activeFilters.value.locations[loc] = false; // Abwählen initialisiert
  }
  localStorage.setItem("LocationFilter", JSON.stringify(activeFilters.value.locations))
}


// Angepasste initializeFilters Funktion
let filtersInitialized = false; // Flag beibehalten
const initializeFilters = () => {
  if (filtersInitialized) {
      return; 
  }
  const initialEventTypes: Record<string, boolean> = {};
  const initialLocations: Record<string, boolean> = {};

  Object.keys(eventTypes.value).forEach(key => {
    initialEventTypes[key] = true; 
  });

  Object.keys(locationTypes.value).forEach(key => {
    initialLocations[key] = true; 
  });

  const initialDays = { day1: true, day2: true };

  activeFilters.value = {
      eventTypes: initialEventTypes,
      days: initialDays,
      locations: initialLocations
  };

  filtersInitialized = true; 
  emit('update:activeFilters', activeFilters.value);
};

// Computed property für gefilterte Events (wird von Standard-Ansicht gebraucht)
const filteredEvents = computed<AgendaPoint[]>(() => {
  // Nur relevant, wenn nicht Timeline
  if (props.agendatype === 'timeline') return []; 

  let items: AgendaPoint[] = [];
  
  // Sicherstellen, dass agendaPointsDay1.value ein Array von AgendaPoint ist
  const day1Points = Array.isArray(agendaPointsDay1.value) 
                      ? agendaPointsDay1.value.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item)
                      : [];
  // Sicherstellen, dass agendaPointsDay2.value ein Array von AgendaPoint ist
  const day2Points = Array.isArray(agendaPointsDay2.value) 
                      ? agendaPointsDay2.value.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item)
                      : [];

  if (activeFilters.value.days.day1) {
      items = items.concat(day1Points);
  }
  if (activeFilters.value.days.day2) {
      items = items.concat(day2Points);
  }
  
  // filterItems erwartet AgendaPoint[] und wendet weitere Filter an
  const filtered = filterItems(items); 
  // Letzte Sicherheitsprüfung für den Linter
  return filtered.filter((item): item is AgendaPoint => !!item && typeof item === 'object' && 'objvalueid' in item);
});

// Lifecycle Hooks
onMounted(async () => {
  if (!store.getters['i/orderedAgendaPoints'] || store.getters['i/orderedAgendaPoints'].length === 0) {
      await store.dispatch("i/fetchAgenda");
  }

  initializeFilters();
});

</script>

<style scoped>
/* ... css ... */

/* Klasse für kleinere Filter-Button Schrift UND Padding */
.filter-button-sm {
  font-size: 0.8rem;  
  padding: 0.25rem 0.5rem; 
}

/* Spezifische Hintergrundfarben für Event-Typ-Filterbuttons (BASIEREND AUF BORDER-DEFINITIONEN) */

.btn.et6 { /* Plenary (war --primary-dw-light-blue Border) */
  background-color: var(--primary-dw-light-blue) !important;
  color: #fff !important; /* Annahme: Dunkler Text auf hellem Blau */
  border-color: transparent !important;
}
.btn.et7 { /* Breakout (war #f29100 Border) */
  background-color: #f29100 !important; /* Orange */
  color: #fff !important; /* Heller Text auf Orange */
  border-color: transparent !important;
}
.btn.et5 { /* Exhibitor (war --gmf-pink Border) */
  background-color: var(--gmf-pink) !important;
  color: #fff !important; /* Heller Text auf Pink? Ggf. anpassen */
  border-color: transparent !important;
}
.btn.et4 { /* Networking (war #adb5bd Border) */
  background-color: #adb5bd !important; /* Grau */
  color: #fff !important; /* Dunkler Text auf Grau */
  border-color: transparent !important;
}

/* Fallback-Style für et-default (bleibt) */
.btn.et-default {
  background-color: #f8f9fa !important; 
  color: #212529 !important;
  border-color: #dee2e6 !important; 
}

/* Optional: Sicherstellen, dass die Icons gut sichtbar sind (bleibt) */
.filter-button-sm i {
    /* Ggf. Farbe oder Größe anpassen, ggf. pro Button-Typ */
    /* z.B. .btn.et7 i { color: white !important; } */
}

.btn-group{
  box-shadow: none !important;
}
</style>
